enum FccOrderRoutes {
  List = '/fcc-orders',
}

export default FccOrderRoutes
